import "../styles/app.scss";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { useEffect, useMemo, useRef, useState } from "react";

import axios from "axios";

import SphereCustom from "../components/Sphere";
import SingleEpisode from "../components/SingleEpisode";
import { episodeUrl, episodeUrl11 } from "../components/UrlArticles";
import PresentationEpisode from "../components/PresentationEpisode";
import TitleEpisode from "../components/EpisodeTitle";

function LaserBeam({ position, rotation, scale, color }) {
  return (
    <mesh position={position} rotation={rotation} scale={scale} visible={true} frustumCulled={false} renderOrder={-1} raycast={() => null}>
      {" "}
      <cylinderGeometry args={[0.03, 0.03, 10, 32]} />
      <meshPhysicalMaterial
        color={color}
        emissive={color}
        emissiveIntensity={3}
        metalness={0.8}
        roughness={0.1}
        transparent
        opacity={1}
        depthWrite={false}
        depthTest={true}
      />
    </mesh>
  );
}

function LaserEnvironment() {
  const group = useRef();

  useFrame((state) => {
    if (group.current) {
      group.current.rotation.y = state.clock.elapsedTime * 0.03;
    }
  });

  const flashyColors = ["#ff00ff", "#00ffff", "#39ff14", "#ff0033", "#ffff00", "#ff6600", "#6600ff", "#00ff99"];

  const lasers = useMemo(() => {
    let temp = [];

    for (let i = 0; i < 140; i++) {
      temp.push({
        position: [(Math.random() - 0.5) * 40, (Math.random() - 0.5) * 40, (Math.random() - 0.5) * 40],

        rotation: [Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI],

        scale: [1, Math.random() * 5 + 1, 1],

        color: flashyColors[Math.floor(Math.random() * flashyColors.length)],
      });
    }

    return temp;
  }, []);

  return (
    <group ref={group}>
      {lasers.map((laser, index) => (
        <LaserBeam key={index} position={laser.position} rotation={laser.rotation} scale={laser.scale} color={laser.color} />
      ))}
    </group>
  );
}

function FloatingSphere({ post, index, showEpisode }) {
  const ref = useRef();

  const initialPosition = useMemo(() => {
    const toNumber = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    return {
      x: toNumber(post?.acf?.x),
      y: toNumber(post?.acf?.y),
      z: toNumber(post?.acf?.z),
      offset: Math.random() * Math.PI * 2,
      speed: 0.5 + Math.random(),
    };
  }, [post]);

  return (
    <group ref={ref} position={[initialPosition.x, initialPosition.y, initialPosition.z]} onClick={() => showEpisode(post.id)}>
      <SphereCustom nom={post.acf.nom} posX={0} posY={0} posZ={0} disableOcclude={true} />
    </group>
  );
}

function Episode11() {
  const [post, setPost] = useState(null);
  const [episode, setEpisode] = useState(null);
  const [visible, setVisible] = useState(false);
  const [about, setAbout] = useState(false);
  const [presentation, setPresentation] = useState(null);
  const [titleHover, setTitleHover] = useState(false);

  let aboutClass = visible ? "visible" : "not-visible";

  let presClass = about ? "visible" : "not-visible";

  useEffect(() => {
    document.body.style.cursor = titleHover ? "pointer" : "grab";
  }, [titleHover]);

  useEffect(() => {
    axios.get(episodeUrl11).then((response) => {
      let thisEpisode = response.data;

      setPost(thisEpisode);
    });

    axios.get(episodeUrl).then((response) => {
      let thisPres = response.data.filter((obj) => {
        return obj.acf.numero === "11";
      });

      setPresentation(thisPres);
    });
  }, []);

  const showEpisode = (id) => {
    let thisEpisode = post.filter((obj) => {
      return obj.id === id;
    });

    setEpisode(thisEpisode);

    setVisible((state) => !state);
  };

  if (!post) return null;
  if (!presentation) return null;

  return (
    <div className="canvas">
      <Canvas
        camera={{
          position: [0, 0, 18],
          fov: 65,
        }}
      >
        <color attach="background" args={["black"]} />

        <fog attach="fog" args={["black", 8, 50]} />

        <ambientLight intensity={0.15} />

        <pointLight position={[0, 0, 0]} intensity={2} color="white" />

        <pointLight position={[10, 10, 10]} intensity={1} color="#ff00ff" />

        <pointLight position={[-10, -10, -10]} intensity={1} color="#00ffff" />

        <LaserEnvironment />

        {post && post.map((post, index) => <FloatingSphere key={post.id} post={post} index={index} showEpisode={showEpisode} />)}

        <OrbitControls enablePan={false} maxDistance={25} minDistance={5} />

        {presentation && (
          <group
            position={[0, 0, 0]}
            onPointerEnter={() => setTitleHover(true)}
            onPointerOut={() => setTitleHover(false)}
            onClick={() => setAbout((state) => !state)}
          >
            <TitleEpisode position={[0, 0, 0]} title={presentation[0].title.rendered} />
          </group>
        )}
      </Canvas>

      <div className={presClass + " about-general"}>
        <PresentationEpisode presentation={presentation} setAbout={setAbout} />
      </div>

      <div className={aboutClass + " about-general"}>
        {episode !== null && <SingleEpisode episode={episode[0]} visible={visible} setVisible={setVisible} />}
      </div>
    </div>
  );
}

export default Episode11;
